import { render, staticRenderFns } from "./epms6020.vue?vue&type=template&id=51056290&scoped=true"
import script from "./epms6020.vue?vue&type=script&lang=js"
export * from "./epms6020.vue?vue&type=script&lang=js"
import style0 from "./epms6020.vue?vue&type=style&index=0&id=51056290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51056290",
  null
  
)

export default component.exports